import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from '../../../environments/environment';
import {LenderUser, RepOnlineStatus} from 'app/models/dto/lender-user.model';

interface TeamMember {
  id: number;
  fullName: string;
}

@Injectable({
  providedIn: 'root',
})

export class LenderUserService {

  constructor(
    private http: ApiHttpClient
  ) { }

  getLenderUsers(): Observable<any> {
    return this.http.get(`${environment.API_URL}/team-member`);
  }

  get(): Observable<LenderUser> {
    return this.http.get<LenderUser>('/lender-user');
  }

  /**
   * search based on query parameters
   *
   * @param searchString
   */
  search(searchString): Observable<TeamMember[] | []> {
    return this.http.get<TeamMember[] | []>(`/team-member/lazy-search?search=${searchString}`);
  }

  update(lenderUserId: number, updates: any): Observable<any> {
    return this.http.put(`${environment.API_URL}/lender-user/${lenderUserId}`, updates);
  }

  updatePausedWorkflow(lenderUserId: number, meta: any): Observable<any> {
    return this.http.put(`${environment.API_URL}/lender-user/${lenderUserId}/update-paused-workflow`, meta);
  }

  uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.API_URL}/avatar`, formData);
  }

  deleteImage() {
    return this.http.delete(`${environment.API_URL}/avatar`);
  }

  changeOnlineStatus(lenderUserId: number, status: string): Observable<RepOnlineStatus> {
    return this.http.post<RepOnlineStatus>(`${environment.API_URL}/lender-user/${lenderUserId}/change-online-status`, {status});
  }
}
